import { CampaignMessageType, CampaignState } from "@regal-voice/shared-types/entities";
import { Select } from "antd";

import { Campaign } from "Types/Campaign";

import { CampaignOptionLabel } from "./CampaignFormOption";
import { campaignSelectMatchesValue } from "./campaignSelectMatchesValue";
import { getCampaignValues } from "./helpers";

type CampaignValue = {
    id: string;
    key?: string;
    label?: string;
    name?: string;
    state?: CampaignState;
    friendlyId?: number;
};

type CampaignSelectProps = {
    value?: CampaignValue;
    callType: CampaignMessageType;
    onChange?: (value?: CampaignValue) => void;
    data: Campaign[];
    placeholder?: string;
    "data-testid"?: string;
};

export function CampaignSelect(props: CampaignSelectProps): JSX.Element {
    const { value, callType, onChange, data, placeholder } = props;

    function handleChange(newCampaignId: string) {
        if (onChange) {
            if (newCampaignId) {
                onChange({ id: newCampaignId, ...getCampaignValues(data, newCampaignId) });
            } else {
                onChange(); // called when we clear the value
            }
        }
    }

    return (
        <Select
            showSearch
            allowClear
            optionFilterProp="label"
            onChange={handleChange}
            placeholder={placeholder}
            value={value?.id}
            data-testid={props["data-testid"]}
            filterOption={campaignSelectMatchesValue}
            options={data.map((campaign: Campaign) => ({
                label: <CampaignOptionLabel campaign={campaign} actionType={callType} />,
                value: campaign.id,
            }))}
        />
    );
}
